window.$ = window.jQuery = require('jquery');
require('./vendor/modernizr-custom');
require("@popperjs/core");
require ('bootstrap');
require('jquery-nice-select');
require("@fancyapps/fancybox");

import AOS from 'aos';

import objectFitVideos from 'object-fit-videos';
import objectFitImages from 'object-fit-images';

import nav from './_nav';
import gaEvents from './vendor/ga-events';
import forms from './_forms';
import sliders from './_sliders';
import pagination from './_pagination';
import gMap from './_map';
import fancybox from './_fancybox';
import accordions from './_accordions';
import modules from './_modules';
import projects from './_projects';
import blog from './_blog';

$(function() { // Shorthand for $( document ).ready()
    "use strict";
    // Your js script is below this line
    // --------------------------------------------------------------------- //

    window.Nav = new nav();
    Nav.init();

    window.GA = new gaEvents();
    GA.init();

    window.Forms = new forms();
    Forms.init();

    window.Modules = new modules();
    Modules.init();

    window.Fancybox = new fancybox();
    Fancybox.init();

    window.Accordions = new accordions();
    Accordions.init();

    window.Projects = new projects();
    Projects.init();

    window.Blog = new blog();
    Blog.init();

    $(document).ready(function() {
        $('html').addClass('ready');
    });

    AOS.init({
        once: true,
        duration: 500,
        offset: 300,
        disable: function() {
            return window.innerWidth < 992;
        }
    });

    // Sets inputs as filled when Google autocomplete prefills them
    $(window).on('load', function() {
        $('input:-webkit-autofill').each(function(){
            $(this).parents('.form-group').addClass('focused filled');
        });
    });

    objectFitVideos();
    objectFitImages('img');
});